import { Button, Modal } from "antd";
import { useState } from "react";
import "../../components/design/CreateFolderModal.scss";
import { DsaUploadFolderDto } from "../../generated/dashboard-client";
import DSAApi from "../../api/DSAApi";

export interface DsaDeleteFolderModalProps {
  folder: DsaUploadFolderDto | null;
  isVisible: boolean;
  onClose: (removed: number) => void;
}

export function DsaDeleteFolderModal({
  folder,
  isVisible,
  onClose
}: DsaDeleteFolderModalProps) {
  const [saving, setSaving] = useState(false);

  function remove() {
    setSaving(true);
    DSAApi.deleteFolder(folder?.id!)
      .then(() => {
        onClose(folder?.id!);
        setSaving(false);
      })
      .catch(() => {
        setSaving(false);
      });
  }

  return (
    <Modal
      className={"create-folder-modal clean"}
      visible={isVisible}
      onCancel={() => onClose(0)}
    >
      <header>
        <h2>Delete {folder?.name}?</h2>
      </header>

      <p>
        Uploads will not be deleted. <br />
        All your uploads are stored in the Uploads tab.
      </p>

      <footer>
        <Button size={"large"} onClick={() => onClose(0)}>
          Cancel
        </Button>
        <Button
          size={"large"}
          className={"primary"}
          onClick={remove}
          loading={saving}
        >
          Delete Folder
        </Button>
      </footer>
    </Modal>
  );
}
